module.exports = __webpack_public_path__ + "static/media/registry-valuable-product-cropped.7b1bf839.jpg";